import { environment } from '@env/environment';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { AttachUploadFileService } from './attach-upload-file.service';

import {
  DomSanitizer
} from '@angular/platform-browser';

@Component({
  selector: 'app-attach-upload-file',
  templateUrl: './attach-upload-file.component.html',
  styleUrls: ['./attach-upload-file.component.scss'],
})
export class AttachUploadFileComponent implements OnInit {
  /**
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false,
   *      isTypeValid: false,
   *      isSizeNameValid: false
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354
   *    ],
   *    invalid: false
   *  }
   */
  @Output() filesAttachedData = new EventEmitter<any>();
  @Input() isRequire = false;
  @Input() examenNumero = '';
  @Input() isExamen = true;
  @Input() attachedFilesFromBackend: any[] = [];
  @Input() viewMode: any;
  @Input() esAunPorEnviar = false;
  @Input() max = 5;
  @Input() lanzarAlert = true;

  public fileList: any[] = [];
  public fileToSendParentList: any[] = [];
  public validatedFile: any;
  public displayFileList = false;
  public disableLoader = false;

  @ViewChild('inputFile') myInputVariable: ElementRef;

  constructor(
    private sanitizer: DomSanitizer,
    private attachUploadFileService: AttachUploadFileService,
    public messageAlertService: MessageAlertService
  ) { }

  ngOnInit(): void {
    let pasa = (this.attachedFilesFromBackend) ? true : false;
    if (pasa) {
      this.attachedFilesFromBackend.forEach((fileItem) => {
        if (fileItem?.nombreRepositorio) {
          this._getAttachedItemFromApi(fileItem);
        } else {
          this._getAttachedItemFromOfflineDB(fileItem);
        }
      });
    } else {
      this.filesAttachedData.emit({
        data: [],
        errors: {},
        invalid: this._isInvalidField(),
        isEmpty: this.fileList.length <= 0
      });
    }
    if (this.viewMode === 'ver') {
      this.disableLoader = true;
    }
  }

  sendDataToParent(): void {
    this.filesAttachedData.emit({
      data: this.fileToSendParentList,
      errors: this.validatedFile,
      invalid: this._isInvalidField(),
      isEmpty: this.fileList.length <= 0,
      attachedFilesValidQuantity: this.validItemCounter()
    });
  }

  public async onUpload(event: any): Promise<void> {
    for (const file of event.currentTarget.files) {
      const reader: any = new FileReader();
      this.validatedFile = this.validateFile(file);
      let fileItemData = {};

      if (this.validatedFile.isSizeValid && this.validatedFile.isTypeValid && !this.validatedFile.isNameDuplicated) {
        reader.onloadend = () => {
          const loadTime = new Date().getTime();
          fileItemData = {
            loadTime,
            archivoBase64: this.sanitizer.bypassSecurityTrustResourceUrl(
              reader.result
            ),
            name: file.name,
            type: file.type.split('/')[1],
            size: file.size,
            alta: (this.viewMode === 'edit') || (!this.isExamen ? true : false)
          };

          this.fileToSendParentList.push({
            loadTime,
            archivoBase64: reader.result.split(',')[1],
            nombreOriginal: file.name,
            tipo: file.type.split('/')[1],
            size: file.size,
            alta: (this.viewMode === 'edit') || (!this.isExamen ? true : false)
          });

          this.fileList.push(fileItemData);
          this.displayFileList = this.fileList.length >= 1;
          this.disableLoader = this.fileList.length >= this.max;

          this.sendDataToParent();
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      } else {
        this.sendDataToParent();
      }
    }

    if (this.myInputVariable?.nativeElement?.value) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  removeFile(file: any): void {

    if (this.viewMode === 'edit' && !this.esAunPorEnviar && !file.alta || !this.isExamen) {
      this._removeOnEdit(file);
    } else {
      this.fileList = this.fileList.filter((value) => {
        return value.loadTime !== file.loadTime;
      });
      this.fileToSendParentList = this.fileToSendParentList.filter((value) => {
        return value.loadTime !== file.loadTime;
      });
    }

    this.disableLoader = this.fileList.length >= this.max;
    this.displayFileList = !(this.fileList.length <= 0);

    this.sendDataToParent();

    if (this.myInputVariable?.nativeElement?.value) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  downloadFile(file): void {
    // nada
  }

  validateFile(file: File): any {
    const errors = {
      isSizeValid: this._isValidSize(file),
      isTypeValid: this._isValidType(file),
      isSizeNameValid: this._isSizeNameValid(file),
      isNameDuplicated: this._isNameDuplicated(file),
    };

    if (this.lanzarAlert) {
      if (!errors.isSizeValid && !errors.isTypeValid) {
        /// lanzo el mensaje de alerta combinado
        this.messageAlertService.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'El tamaño y tipo de archivo no son los permitidos. (Archivo es 5 Mb y Tipos son .jpg - .png - .bmp - .pdf)',
          key: 'examen',
        });
        setTimeout(() => {
          const header = document.querySelector('#templateContainer') as any;
          window.scroll(0, header.offsetTop - 150);
        }, 100);
      }

      if (!errors.isSizeValid) {
        /// lanzo el mensaje de alerta de tamaño
        this.messageAlertService.setMessage(0, {
          severity: 'error',
          summary: '',
          detail: 'El tamaño máximo de cada archivo puede ser 5 Mb',
          key: 'examen',
        });

        this.myInputVariable.nativeElement.value = '';
        // console.log('affter mesage: ', this.myInputVariable.nativeElement.files);
        setTimeout(() => {
          const header = document.querySelector('#templateContainer') as any;
          window.scroll(0, header.offsetTop - 150);
        }, 100);
      }

      if (!errors.isTypeValid) {
        /// lanzo el alert de tamaño
        this.messageAlertService.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Los tipos de archivo permitidos son (.jpg - .png - .bmp - .pdf)',
          key: 'examen',
        });
        setTimeout(() => {
          const header = document.querySelector('#templateContainer') as any;
          window.scroll(0, header.offsetTop - 150);
        }, 100);
      }

      if (!errors.isSizeNameValid) {
        /// lanzo el alert de tamaño
        this.messageAlertService.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'El nombre del archivo excede la longitud permitida de 60 caracteres',
          key: 'examen',
        });
        setTimeout(() => {
          const header = document.querySelector('#templateContainer') as any;
          window.scroll(0, header.offsetTop - 150);
        }, 100);
      }

      if (errors.isNameDuplicated) {
        /// lanzo el alert de duplicado
        this.messageAlertService.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ya se encuentra adjunto otro archivo con el mismo nombre',
          key: 'examen',
        });
        setTimeout(() => {
          const header = document.querySelector('#templateContainer') as any;
          window.scroll(0, header.offsetTop - 150);
        }, 100);
      }
    }
    return errors;
  }

  validItemCounter() {
    let validItems = this.fileToSendParentList.filter(value => {
      return value.baja !== true
    });
    // console.log(validItems);
    return validItems.length;
  }

  _isValidType(file): boolean {
    const validType = [
      'image/bmp',
      'image/jpeg',
      'image/png',
      'application/pdf',
    ];
    return validType.includes(file.type);
  }

  _isValidSize(file): boolean {
    const maxValidSize = 5242880;
    return file.size <= maxValidSize;
  }

  _isSizeNameValid(file): boolean {
    return file.name.length <= 64;
  }

  _isNameDuplicated(file): boolean {
    if (this.fileList.length === 0) {
      return false;
    } else {
      let duplicates = this.fileList.filter(value => { return value.name === file.name });
      return duplicates.length > 0
    }
  }

  _isInvalidField(): boolean {
    let isInvalid = false;
    //  si es requerido y esta vació
    if (this.isRequire) {
      isInvalid = this.isRequire && this.fileList.length <= 0;
    }
    return isInvalid;
  }

  _removeOnEdit(file) {

    this.fileList = this.fileList.filter((value) => {
      return value.loadTime !== file.loadTime;
    });
    this.fileToSendParentList = this.fileToSendParentList.filter(value => {
      return (value.nombreRepositorio === file.nombreRepositorio) ? value.baja = true : value;
    })
    this.validatedFile = {
      isSizeValid: true,
      isTypeValid: true,
      isSizeNameValid: true,
    };
  }

  _createDataUrl(fileItem) {
    let dataUri = '';

    if (fileItem.tipo === 'pdf') {
      dataUri = `data:application/pdf;base64,${fileItem.archivoBase64}`;
    }
    if (fileItem.tipo !== 'pdf') {
      dataUri = `data:${fileItem.tipo};base64,${fileItem.archivoBase64}`;
    }
    return dataUri;
  }

  _getAttachedItemFromApi(fileItem) {
    let item = {
      ...fileItem
    };

    if (fileItem.nombreRepositorio) {
      item.loadTime = parseInt(fileItem.nombreRepositorio.replace(/[A-Za-z]/g, ''));
    }

    (fileItem.nombreOriginal) ? item.name = fileItem.nombreOriginal : fileItem.name;

    this.fileToSendParentList.push(fileItem);
    this.fileList.push(item);

    this.displayFileList = this.fileList.length >= 1;
    this.disableLoader = this.fileList.length >= this.max;
    if (this.viewMode === 'ver') {
      this.disableLoader = true;
    }

    this.filesAttachedData.emit({
      data: this.fileToSendParentList,
      errors: {
        isSizeValid: true,
        isTypeValid: true,
        isSizeNameValid: true
      },
      invalid: false,
      isEmpty: this.validItemCounter() <= 0,
      attachedFilesValidQuantity: this.validItemCounter()
    });

    // Me traigo el archivo lo combierto en base 64 y se lo pego al link
    this.attachUploadFileService.getAttachedFileFromApi({
      idAsociado: this.examenNumero,
      nombreRepositorio: fileItem.nombreRepositorio,
      isExamen: this.isExamen
    }).subscribe(data => {
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        // fileItem.archivoBase64 = reader.result;
        let img: any = reader.result;
        item.archivoBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(img);
      }, false);

      if (data) {
        reader.readAsDataURL(data);
      }
    }, error => {
      console.log(error);
    });
  }

  _getAttachedItemFromOfflineDB(fileItem) {
    let item = {
      ...fileItem,
      loadTime: fileItem.loadTime,
      archivoBase64: this.sanitizer.bypassSecurityTrustResourceUrl(`data:${fileItem.tipo};base64,${fileItem.archivoBase64}`),
      name: fileItem.nombreOriginal,
      tipo: fileItem.tipo,
      size: fileItem.size,
      alta: (this.viewMode === 'edit')
    };
    this.fileToSendParentList.push(fileItem);
    this.fileList.push(item);

    this.displayFileList = this.fileList.length >= 1;
    this.disableLoader = this.fileList.length >= this.max;

    this.filesAttachedData.emit({
      data: this.fileToSendParentList,
      errors: {
        isSizeValid: true,
        isTypeValid: true,
        isSizeNameValid: true
      },
      invalid: false,
      isEmpty: false,
      attachedFilesValidQuantity: this.validItemCounter()
    });
  }
}
